import { useState } from 'react';
import { useNavigate } from 'react-router';

import { LogoutConfirmationModal } from '@/components/ui/logout-confirmation-modal';
import {
  MenuItem,
  Menu,
  MenuSeparator,
  useMenuContext,
} from '@/components/ui/menu';
import { env } from '@/config/env';
import { paths } from '@/config/paths';
import { handleLogout, useAuth } from '@/features/auth';
import { useProfilesData } from '@/features/user';

export const UserMenu = () => {
  const navigate = useNavigate();
  const { isLoggingOut } = useAuth();
  const { selectedProfile, selectedCourse, studentProfiles } =
    useProfilesData();
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const { closeMenu } = useMenuContext();

  const handleSwitchProfile = async () => {
    await navigate(paths.profile.select.getHref());
  };

  const handleMyProfiles = async () => {
    if (closeMenu) closeMenu();
    await navigate(paths.app.profiles.getHref());
  };

  const handleSignOut = () => {
    setShowLogoutConfirm(true);
  };

  const handleConfirmLogout = () => {
    handleLogout();
    setShowLogoutConfirm(false);
  };

  const handleCancelLogout = () => {
    setShowLogoutConfirm(false);
  };

  return (
    <>
      <Menu size="md">
        <div className="text-sm text-magical-moonlight-d1 p-4">
          <span className="font-bold">{selectedProfile?.name}</span>
          <br />
          {selectedCourse?.course_name ? (
            <span className="font-bold">
              {env.IS_OFFLINE ? 'Level - ' : ''}
              {selectedCourse?.course_name}
            </span>
          ) : null}
        </div>
        {studentProfiles.length > 1 && (
          <>
            <MenuItem onClick={() => void handleSwitchProfile()}>
              Switch Profile
            </MenuItem>
          </>
        )}
        {!env.IS_OFFLINE && (
          <MenuItem onClick={() => void handleMyProfiles()}>
            My Profiles
          </MenuItem>
        )}
        <MenuSeparator />
        <MenuItem variant="destructive" onClick={handleSignOut}>
          Sign Out
        </MenuItem>
      </Menu>

      <LogoutConfirmationModal
        isOpen={showLogoutConfirm}
        onClose={handleCancelLogout}
        onConfirmLogout={handleConfirmLogout}
        isLoading={isLoggingOut}
      />
    </>
  );
};

export default UserMenu;
